interface ShopsBudgetProps {
  shopsPlaced: number;
  shopsScheduled: number;
  shopsTotal: number;
  billingStartDate?: string | null;
  billingEndDate?: string | null;
}

function formatBillingDate(dateStr: string): string {
  return new Date(dateStr + 'T00:00:00').toLocaleDateString('en-US', { month: 'short', day: 'numeric' });
}

export function ShopsBudget({ shopsPlaced, shopsScheduled, shopsTotal, billingStartDate, billingEndDate }: ShopsBudgetProps) {
  const remaining = Math.max(0, shopsTotal - shopsPlaced - shopsScheduled);
  const color = remaining > 0 ? 'text-black' : 'text-gray-400';

  return (
    <span className={`text-sm ${color}`}>
      Shops Budget: {shopsPlaced} Placed / {shopsScheduled} Scheduled / <span className={remaining > 0 ? 'font-bold' : ''}>{remaining}</span> Remaining
      {billingStartDate && billingEndDate && (
        <span className="ml-2">{formatBillingDate(billingStartDate)} – {formatBillingDate(billingEndDate)}, {new Date(billingEndDate + 'T00:00:00').getFullYear()}</span>
      )}
    </span>
  );
}
